import React, { FC, ReactNode } from 'react';
import clsx from 'clsx';
import useClassNames from 'helpers/hooks/useClassNames';

export type WrapperBackground = 'white' | 'neutral-200';

export type WrapperProps = {
  children: ReactNode;
  background?: WrapperBackground;
  className?: string;
  clearDefaultStyles?: boolean;
  containerWidth?: boolean;
};

const Wrapper: FC<WrapperProps> = ({ children, background = 'white', className, clearDefaultStyles, containerWidth = false }) => {
  const wrapperClassName = useClassNames(
    clearDefaultStyles ? [className] : [className, 'px-16 md:px-24 lg:px-20 xl:px-48'],
  );

  return (
    <div className={clsx([background === 'white' ? 'bg-white dark:bg-gmsb-header-gray' : 'bg-neutral-200', containerWidth && 'container' ])}>
      <div className={wrapperClassName}>{children}</div>
    </div>
  );
};

export default Wrapper;
